import React from 'react'

const WorkProgressBar = ({ percent = 0, showLabel = true, size = 'default' }) => {
  const height = size === 'small' ? 6 : 8
  const width = '100%'

  if (percent === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', width, gap: 8, height }}>
        <span style={{ fontSize: 13, color: '#bfbfbf' }}>—</span>
      </div>
    )
  }

  let color = '#ff4d4f' // < 33%: Đỏ
  if (percent >= 100) {
    color = '#52c41a' // 100%: Xanh lá
  } else if (percent >= 67) {
    color = '#1890ff' // 67-99%: Xanh dương
  } else if (percent >= 34) {
    color = '#faad14' // 34-66%: Vàng
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', width, gap: 8 }}>
      <div 
        style={{ 
          flex: 1, 
          height, 
          backgroundColor: '#f5f5f5', 
          borderRadius: 100, 
          overflow: 'hidden' 
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${percent}%`,
            backgroundColor: color,
            borderRadius: 100,
            transition: 'width 0.3s ease, background-color 0.3s ease'
          }}
        />
      </div>
      {showLabel && (
        <span style={{ fontSize: 13, color: '#595959', minWidth: 35 }}>
          {percent}%
        </span>
      )}
    </div>
  )
}

export default WorkProgressBar
